export default __webpack_public_path__ + "static/media/05_May.cb9d66fa.png";